module.exports = __webpack_public_path__ + "static/img/button4.c2826dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/button4.png
// module id = mrQk
// module chunks = 4